import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import InputMask from 'react-input-mask';
import usePutData from "repo/put";

const EditHoursDialog = ({ selectedData, onSave, onCancel }) => {
    const [formData, setFormData] = useState({ ...selectedData });
    const [hourValidationError, setHourValidationError] = useState(false);

    const handleChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
    };

    const { putData } = usePutData();

    const handleSave = async () => {
        if (!validateTime(formData.hour_first) || !validateTime(formData.hour_dinner) || !validateTime(formData.hour_stop) || !validateTime(formData.hour_finish)) {
            setHourValidationError(true);
            return;
        }

        try {
            const apiDate = formData.date.replace( '/', '-').replace( '/', '-');
            const response = await putData(`api/pontos/update/${formData.id}`, {
                date: apiDate,
                hour_first: formData.hour_first,
                hour_dinner: formData.hour_dinner,
                hour_stop: formData.hour_finish,
                hour_finish: formData.hour_stop,
            });

            onSave(response);
        } catch (error) {
            console.error(error);
        }
    };

    const handleBlur = (field) => {
        if (!validateTime(formData[field])) {
            setHourValidationError(true);
        } else {
            setHourValidationError(false);
        }
    };

    const validateTime = (time) => {
        if (!time) return true; 
        const regex = /^([01][0-9]|2[0-3]):([0-5][0-9])$/;
        return regex.test(time);
    };

    return (
        <Dialog
            header={formData.date}
            visible={!!selectedData}
            style={{ width: "400px" }}
            modal
            onHide={onCancel}
        >
            <div className="p-fluid">
                <div className="flex items-start justify-between mt-8">
                    <div className="flex-1">
                        <div className="relative w-full mb-3">
                            <label className="block uppercase text-blueGray-600 text-xs font-bold ">
                                Início
                            </label>
                            <InputMask
                                mask="99:99"
                                value={formData.hour_first}
                                className={`border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 ${hourValidationError && !validateTime(formData.hour_first) ? 'border-red-500' : ''}`}
                                onChange={(e) => handleChange("hour_first", e.target.value)}
                                placeholder="HH:MM"
                                onBlur={() => handleBlur("hour_first")}
                            />
                        </div>
                        <div className="relative w-full mb-3">
                            <label className="block uppercase text-blueGray-600 text-xs font-bold ">
                                Almoço
                            </label>
                            <InputMask
                                mask="99:99"
                                value={formData.hour_dinner}
                                className={`border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 ${hourValidationError && !validateTime(formData.hour_dinner) ? 'border-red-500' : ''}`}
                                onChange={(e) => handleChange("hour_dinner", e.target.value)}
                                placeholder="HH:MM"
                                onBlur={() => handleBlur("hour_dinner")}
                            />
                        </div>
                        <div className="relative w-full mb-3">
                            <label className="block uppercase text-blueGray-600 text-xs font-bold ">
                                Retorno
                            </label>
                            <InputMask
                                mask="99:99"
                                value={formData.hour_stop}
                                className={`border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 ${hourValidationError && !validateTime(formData.hour_stop) ? 'border-red-500' : ''}`}
                                onChange={(e) => handleChange("hour_stop", e.target.value)}
                                placeholder="HH:MM"
                                onBlur={() => handleBlur("hour_stop")}
                            />
                        </div>
                        <div className="relative w-full mb-3">
                            <label className="block uppercase text-blueGray-600 text-xs font-bold ">
                                Fim
                            </label>
                            <InputMask
                                mask="99:99"
                                value={formData.hour_finish}
                                className={`border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 ${hourValidationError && !validateTime(formData.hour_finish) ? 'border-red-500' : ''}`}
                                onChange={(e) => handleChange("hour_finish", e.target.value)}
                                placeholder="HH:MM"
                                onBlur={() => handleBlur("hour_finish")}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <Button className="bg-emerald-500 text-white px-3 py-1 rounded-md shadow hover:bg-green-600 font-bold m-4" label="Salvar" icon="pi pi-check" onClick={handleSave} />
            <Button className="bg-red-500 text-white px-3 py-1 rounded-md shadow hover:bg-red-600 font-bold m-4" label="Cancelar" icon="pi pi-times" onClick={onCancel} />
        </Dialog>
    );
};

export default EditHoursDialog;
